<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    
    <!-- 这里添加商品选择的具体内容 -->
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="搜索商品名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-button class="filter-item" type="primary" @click="handleFilter">
        搜索
      </el-button>
    </div>

    <el-table
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="商品图片" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.coverPhoto" style="width: 60px; height: 60px; border-radius: 5px;">
        </template>
      </el-table-column>
      <el-table-column label="商品名称" prop="prodName" align="center" />
      <el-table-column label="规格" prop="specName" align="center" />
      <el-table-column label="库存" prop="stock" align="center" />
      <el-table-column label="单价" prop="price" align="center" />
    </el-table>

    <el-pagination
      :current-page="listQuery.page"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="listQuery.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSelection">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getPartnerGoodsList } from '@/api/partner/transferPartnerGoodsApi'

export default {
  name: 'ChoosePartnerGoods',
  data() {
    return {
      dialogVisible: false,
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        keyword: '',
        ppId: ''
      },
      selectedProducts: []
    }
  },
  methods: {
    open(params) {
      this.listQuery.ppId = params.ppId
      this.dialogVisible = true
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          console.log(_)
          done()
        })
        .catch(_ => {
                    console.log(_)

        })
    },
    getList() {
      getPartnerGoodsList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.selectedProducts = val
    },
    confirmSelection() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品')
        return
      }
      this.$emit('chooseParknerGoods', ...this.selectedProducts)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
</style>